export const publish = (data) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger(
      'spotlight_rich_text.content-click',
      data
    );
  }
};